module.exports = __webpack_public_path__ + "static/media/br.8223d1c3.svg";